export default class PrivacyView {
  constructor() {
    this.eventHandlers = {};
  }

  async render() {
    return `
      <div id="page-privacy" class="page-content active">
        <div class="policy-page">
          <div class="policy-header">
            <h2 id="privacy-title"></h2>
            <p class="policy-date" id="privacy-date"></p>
          </div>

          <div class="policy-content" id="privacy-content">
          </div>

          <div class="back-action">
            <button type="button" id="privacy-back-btn" class="post-submit" data-text_tip="Kembali ke halaman sebelumnya" data-hover_tip="bottom" data-dev_tip="desktop" aria-label="Kembali ke halaman sebelumnya">
              <span class="material-symbols-rounded" aria-hidden="true">arrow_back</span>
              <span>Kembali</span>
            </button>
          </div>
        </div>
      </div>
    `;
  }

  async afterRender() {
    // Setup handled by presenter
  }

  renderPageHeader(pageData) {
    const titleElement = this.getTitleElement();
    const dateElement = this.getDateElement();
    
    if (titleElement) {
      titleElement.textContent = pageData.title;
    }
    
    if (dateElement) {
      dateElement.textContent = `Terakhir diperbarui: ${pageData.lastUpdated}`;
    }
  }

  renderContent(policyContent) {
    const contentContainer = this.getContentContainer();
    if (!contentContainer) return;

    let contentHtml = '';
    
    policyContent.sections.forEach(section => {
      contentHtml += `<section>`;
      contentHtml += `<h3>${this.escapeHtml(section.title)}</h3>`;
      
      if (section.content) {
        contentHtml += `<p>${this.escapeHtml(section.content)}</p>`;
      }
      
      if (section.list) {
        contentHtml += `<ul>`;
        section.list.forEach(item => {
          contentHtml += `<li>${this.escapeHtml(item)}</li>`;
        });
        contentHtml += `</ul>`;
      }
      
      if (section.subsections) {
        section.subsections.forEach(subsection => {
          contentHtml += `<h4>${this.escapeHtml(subsection.title)}</h4>`;
          if (subsection.content) {
            contentHtml += `<p>${this.escapeHtml(subsection.content)}</p>`;
          }
          if (subsection.list) {
            contentHtml += `<ul>`;
            subsection.list.forEach(item => {
              contentHtml += `<li>${this.escapeHtml(item)}</li>`;
            });
            contentHtml += `</ul>`;
          }
        });
      }
      
      if (section.contact) {
        contentHtml += `
          <div class="contact-info">
            <p><strong>Email:</strong> ${this.escapeHtml(section.contact.email)}</p>
            <p><strong>Nama:</strong> ${this.escapeHtml(section.contact.name)}</p>
          </div>
        `;
      }
      
      contentHtml += `</section>`;
    });

    contentContainer.innerHTML = contentHtml;
  }

  setupBackButtonEventListener(onBackClick) {
    const backButton = this.getBackButton();
    if (backButton) {
      this.eventHandlers.backHandler = onBackClick;
      backButton.addEventListener('click', this.eventHandlers.backHandler);
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Helper methods untuk DOM queries
  getTitleElement() {
    return document.querySelector('#privacy-title');
  }

  getDateElement() {
    return document.querySelector('#privacy-date');
  }

  getContentContainer() {
    return document.querySelector('#privacy-content');
  }

  getBackButton() {
    return document.querySelector('#privacy-back-btn');
  }

  cleanupEventListeners() {
    const backButton = this.getBackButton();
    if (backButton && this.eventHandlers.backHandler) {
      backButton.removeEventListener('click', this.eventHandlers.backHandler);
    }

    this.eventHandlers = {};
  }

  cleanup() {
    this.cleanupEventListeners();
  }
}